import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48443b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aspins" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_spin, {
        class: "white-spin",
        size: "large",
        spinning: $setup.isloadding
      }, null, 8, ["spinning"])
    ], 512), [
      [_vShow, $setup.isloadding]
    ]),
    _createVNode(_component_router_view)
  ], 64))
}